module.exports = __webpack_public_path__ + "img/skredfaresoner.f247c7d7.jpg";